
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"47","viewBox":"0 0 48 47"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#36AE61","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M43.368 17.78a3.652 3.652 0 01-1.078 1.752l-1.944 1.756a3.656 3.656 0 000 5.428l1.944 1.756a3.656 3.656 0 01-2.638 6.366l-2.616-.134a3.656 3.656 0 00-3.836 3.838l.134 2.616a3.656 3.656 0 01-6.368 2.642l-1.756-1.944a3.656 3.656 0 00-5.428 0L18.026 43.8a3.656 3.656 0 01-6.366-2.642l.14-2.616a3.656 3.656 0 00-3.838-3.838l-2.616.134a3.656 3.656 0 01-2.638-6.366l1.944-1.756a3.656 3.656 0 000-5.428l-1.944-1.756a3.656 3.656 0 012.632-6.366l2.616.134A3.656 3.656 0 0011.8 9.462l-.14-2.616A3.656 3.656 0 0118.026 4.2l1.756 1.944a3.652 3.652 0 005.428 0L26.966 4.2a3.658 3.658 0 014.114-.92"}}),_c('path',{attrs:{"d":"M15.2 20.282l5.026 6.702a3 3 0 004.694.132L46.496 1.502"}})])])
          )
        }
      }
    